export const meControlQueryParamKey = 'ref';
export const meControlQueryParamValue = 'MeControl';
export const lastTimeSawBannerLocalStorageKey = 'lastTimeSawBanner';
export const msaRedirectUrl = 'https://account.microsoft.com';

export const B2B_LEAVE_HOME_ORG_LINK =
  'https://aka.ms/ManageOrgsWorkOrSchool';
export const LEAVE_ORG_LEARN_MORE_LINK =
  'https://aka.ms/ManageOrgsWorkOrSchool';
export const LAST_ADMIN_LEARN_MORE_LINK =
  'https://learn.microsoft.com/en-us/azure/active-directory/enterprise-users/directory-delete-howto';
export const B2B_COLLAB_VS_DIRECT_CONNECT_LINK = 'https://aka.ms/b2b-collab-vs-direct-connect';

export const QUERY_PARAM_LOGIN_HINT = 'login_hint';
export const QUERY_PARAM_TENANT = 'tenant';

export const P1_SERVICE_PLAN_ID = '41781fb2-bc02-4b7c-bd55-b576c07bb09d';
export const P2_SERVICE_PLAN_ID = 'eec0eb4f-6444-4f95-aba0-50c24d67f998';
export const ENTRA_IDENTITY_GOVERNANCE_SERVICE_PLAN_ID = 'e866a266-3cff-43a3-acca-0c90a7e00c8b';
export const COPILOT_BUSINESS_CHAT_SERVICE_PLAN_ID = '3f30311c-6b1e-48a4-ab79-725b469da960';

export const changeInfoContactUrl = 'https://aka.ms/aadchangeinfocontact';

export const MY_GROUPS_PATH = '/groups';

export const AUTHENTICATOR_LINK = 'https://www.microsoft.com/en-us/security/mobile-authenticator-app';
export const RETRIEVING_CREDENTIALS = 'retrieving-credentials';

export const ENABLE_TOU_QUERY_STRING = 'enabletou';

export const EU_DATA_BOUNDARY_CLAIM_VALUE = 'eu';

export const PAGE_TITLE = 'My Account';

export const VERIFIEDID_APP_NAME_LINKEDIN = 'linkedin';

export enum MSGraphScopes {
  CrossTenantUserProfileSharingReadWriteAll = 'CrossTenantUserProfileSharing.ReadWrite.All',
  OrganizationReadAll = 'Organization.Read.All',
  UserReadAll = 'User.Read.All',
  UserReadWrite = 'User.ReadWrite',
  MailboxSettingsReadWrite = 'MailboxSettings.ReadWrite',
  BitlockerKeyReadAll = 'BitlockerKey.Read.All',
  ContactsRead = 'Contacts.Read',
}

export const MAX_WIDTH = 1680;
export const MOBILE_BREAK_POINT = 's';

export const OFFICE_SERVICES = {
  sharePoint: 'SharePoint',
  exchange: 'exchange',
  microsoftOffice: 'MicrosoftOffice',
  toDo: 'To-Do',
  yammer: 'YammerEnterprise',
  teams: 'TeamspaceAPI',
  powerApps: 'PowerAppsService',
  sway: 'Sway',
};

// route map
interface RoutePath {
  link: string;
  key: string;
  subRoutePaths?: RoutePathMap;
}
type RoutePathMap = Record<string, RoutePath>;
export const NAVIGATION_LINKS: RoutePathMap = {
  overview: { link: '/', key: 'overview' },
  devices: { link: '/device-list', key: 'deviceList' },
  organizations: {
    link: '/organizations',
    key: 'organizations',
    subRoutePaths: {
      leave: { link: '/organizations/leave', key: 'organizations-leave' },
    },
  },
  settingsAndPrivacy: {
    link: '/settingsandprivacy',
    key: 'settingsPrivacy',
    subRoutePaths: {
      privacy: { link: '/settingsandprivacy/privacy', key: 'settingsPrivacy-privacy' },
      language: { link: '/settingsandprivacy/language', key: 'settingsPrivacy-language' },
    },
  },
  groups: { link: '/groups', key: 'groups' },
  termsOfUse: {
    link: '/termsofuse',
    key: 'termsofuse',
    subRoutePaths: {
      consent: { link: '/termsofuse/consent', key: 'termsofuse-consent' },
      myAcceptances: { link: '/termsofuse/myacceptances', key: 'termsofuse-myacceptances' },
    },
  },
};

export enum PROFILE_PHOTO_ALLOWED_OPERATIONS {
  update = 'update',
  delete = 'delete',
}
